import { fetchGuideEmoticonList } from '@module/apis/client-side/guide';
import type { GuideEmoticonListResponse, GuideEmoticonParams } from '@module/apis/client-side/guide/type';
import { useQuery } from '@tanstack/react-query';

import type { CustomUseQueryOptions } from '../type';
import { guideQueryKeys } from './guideQueryKeys';

export const useGuideEmoticonListQuery = (
  fetchGuideEmoticonListParams: GuideEmoticonParams,
  options?: CustomUseQueryOptions<GuideEmoticonListResponse, Error>,
) =>
  useQuery({
    queryKey: guideQueryKeys.fetchGuideEmoticonList(fetchGuideEmoticonListParams).queryKey,
    queryFn: () => fetchGuideEmoticonList(fetchGuideEmoticonListParams),
    ...options,
  });
